/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Minutes, TimeUtils } from '@wit/vtv-x-foundation-lib';
import React, { useEffect } from 'react';
import { TimeLimits } from './TVGuideGrid';

interface Props {
  timeLimits: TimeLimits;
  unitDuration: Minutes;
  unitSize: number;
}

function createTimeArray(timeLimits: TimeLimits, duration: Minutes): string[] {
  let cursor = timeLimits.start;
  const dCursor = TimeUtils.toDestructuredTime(cursor);
  const array = [];
  while (TimeUtils.isBefore(cursor, timeLimits.end)) {
    array.push(TimeUtils.toLocalTimeString(cursor));
    dCursor.minutes += duration;
    cursor = TimeUtils.fromDestructuredTime(dCursor);
  }
  return array;
}

function TVGuideTimeBar({ timeLimits, unitDuration, unitSize }: Props): JSX.Element {
  const [timeArray, setTimeArray] = React.useState<string[]>([]);
  useEffect(() => {
    setTimeArray(createTimeArray(timeLimits, unitDuration));
  }, [timeLimits, unitDuration]);

  return (
    <div className="tv-guide-time-bar tv-guide-background" id="TvGuideGrid_timeBar">
      <ul>
        {timeArray.map((time) => (
          <li key={time} style={{ width: unitSize }} id={`TvGuideGrid_timeBar___${time.replace(':', '')}`}>
            {time}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default React.memo(TVGuideTimeBar);
